import { createContext, useContext } from "react";

import { Tag } from "@/types/Tag";

type TagContextProps = {
  organizationTags: Tag[];
  setOrganizationTags: (tags: Tag[]) => void;
  fetchOrganizationTags: () => void;
};
const TagContext = createContext<TagContextProps>({} as TagContextProps);

export const useTags = () => useContext(TagContext);

export default TagContext;
